import {createContext, Dispatch, SetStateAction} from "react";

export enum GlobalSteps {Load, Comparison, Generation, Fail}

export enum Sides {Undefined , Left, Right}

// Global status
export interface Status {
    globalStep: GlobalSteps;
    percent?: number;
    nextEnabled: boolean;
    projectID?: string;
    temporaryName?: string;
    leftName?: string;
    rightName?: string;
    leftChapters?: Chapter[];
    rightChapters?: Chapter[];
}

export interface Chapter {
    id: string;
    name: string;
    skipped: boolean;
}

export const leftChaptersCount = (status: Status): number => {
    if (!status.leftChapters) {
        return 0
    }
    return status.leftChapters.filter(chapter => !chapter.skipped).length;
}
export const rightChaptersCount = (status: Status): number => {
    if (!status.rightChapters) {
        return 0
    }
    return status.rightChapters.filter(chapter => !chapter.skipped).length;
}


export interface StatusContextType {
    status: Status;
    setStatus: Dispatch<SetStateAction<Status>>;
}

// Global status context
export const StatusContext = createContext<StatusContextType | undefined>(undefined);

export interface Project {
    project_id: string;
    temporary_name: string;
    left_book_name: string;
    right_book_name?: string;
    left_chapters?: ProjectChapter[];
    right_chapters?: ProjectChapter[];
}

export interface ProjectChapter {
    id: string;
    name: string;
    skipped: boolean;
}

export const mapStatusToProject = (status: Status): Project => {
    return {
        project_id: status.projectID || "",
        temporary_name: status.temporaryName || "",
        left_book_name: status.leftName || "",
        right_book_name: status.rightName || "",
        left_chapters: status.leftChapters?.map(chapter => ({
            id: chapter.id,
            name: chapter.name,
            skipped: chapter.skipped,
        })),
        right_chapters: status.rightChapters?.map(chapter => ({
            id: chapter.id,
            name: chapter.name,
            skipped: chapter.skipped,
        })),
    };
};
